import VariableDefaults from './VariableDefaults'
import VariableProvider from './index'

const abundanceEngineExports = {
  VariableProvider,
  VariableDefaults
}

export default abundanceEngineExports
